// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { sanitizeInput } from '@/_helper/inputSanitizer';

// Komponenten
import Button from '@/comp/button/button.tsx';
import Icon from '@/comp/icon/icon';

// Styles
import './claimContactForm.scss';

class ClaimContactForm extends Component {
    state = {
        formValid: false,
        formErrors: {
            email: '',
            emailConfirm: '',
        },
        mailErrorMessage: '',
        equalEmails: false,
    };

    componentDidMount() {
        if (this.props.contactData) {
            this.setState({
                email: this.props.contactData.email,
                emailConfirm: this.props.contactData.email,
            });
            this.isMailConfirmed();
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.state.formValid) {
            let contactData = {
                email: this.state.email,
            };
            this.props.setContactData(contactData);
            this.props.changeStep(3);
        } else {
            let formErrors = this.state.formErrors;
            if (formErrors['emailConfirm'] === undefined) {
                formErrors['emailConfirm'] = [];
                formErrors['emailConfirm'].push(
                    'Bitte geben Sie Ihre E-Mail Adresse an, damit wir Sie über Ihre Reklamation auf dem Laufenden halten können.'
                );
                this.setState({ formErrors: formErrors });
            }
        }
    }

    handleBack(event) {
        event.preventDefault();

        if (this.state.formValid) {
            let contactData = {
                email: this.state.email,
            };
            this.props.setContactData(contactData);
        }
        this.props.changeStep(1);
    }

    isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    isMailConfirmed = () => {
        let formErrors = this.state.formErrors;
        formErrors['emailConfirm'] = [];
        formErrors['email'] = [];

        if (this.state.email === this.state.emailConfirm) {
            this.setState({ formValid: true });
        } else if (this.state.email !== undefined && this.state.emailConfirm !== undefined) {
            formErrors['emailConfirm'] =
                'Die E-Mail Adressen stimmen nicht überein. Bitte überprüfen Sie Ihre Eingabe und versuchen es nochmal.';
            this.setState({ formValid: false });
        }
        this.setState({ formErrors: formErrors });
    };

    handleChange = (event) => {
        const e = event.target;
        let formErrors = this.state.formErrors;
        if (e !== null) {
            formErrors[e.name] = [];
            if (e.value === '') {
                formErrors[e.name].push(
                    'Bitte geben Sie Ihre E-Mail Adresse an, damit wir Sie über Ihre Reklamation auf dem Laufenden halten können.'
                );
                this.setState({ formValid: false });
            } else if (!this.isValidEmail(sanitizeInput(e.value))) {
                formErrors[e.name].push('Ihre E-Mail Adresse muss dem Format beispiel@mail.de entsprechen.');
                this.setState({ formValid: false });
                this.setState({ formValid: false });
            } else {
                this.setState(
                    (state) => {
                        state[e.name] = sanitizeInput(e.value);
                        return state;
                    },
                    () => this.isMailConfirmed(e)
                );
            }

            this.setState({ formErrors: formErrors });
        }
    };

    render() {
        return (
            <>
                <section className="content-wrapper">
                    <div className="intro row">
                        <div className="intro-title">
                            <h1>Ihre Kontaktdaten</h1>
                        </div>
                        <div className="intro-text">
                            <p>
                                Damit wir Sie nach dem Eingang Ihrer Reklamation direkt kontaktieren können, teilen Sie
                                uns bitte
                                <br />
                                Ihre E-Mail Adresse mit. Eine Eingangsbestätigung Ihrer Angaben wird an die mit der
                                Buchung verknüpften E-Mail Adresse gesendet.
                            </p>
                        </div>
                    </div>
                </section>

                {/* FORM */}
                <form
                    className="claim-contact-form"
                    method="post"
                    noValidate
                    onSubmit={(event) => this.handleSubmit(event)}>
                    <section>
                        <article className="article">
                            <div className="container">
                                <div className="input-container">
                                    <label htmlFor="email">Bitte geben Sie Ihre E-Mail Adresse an</label>
                                    <input
                                        type="email"
                                        className={
                                            this.state.formErrors['email'] && this.state.formErrors['email'].length > 0
                                                ? 'error'
                                                : ''
                                        }
                                        name="email"
                                        autoComplete="email"
                                        onBlur={(event) => {
                                            this.handleChange(event);
                                        }}
                                        onChange={(event) => {
                                            this.setState({
                                                email: sanitizeInput(event.target.value),
                                            });
                                        }}
                                        value={this.state.email || ''}
                                    />
                                    {this.state.formErrors['email'] && this.state.formErrors['email'].length > 0 && (
                                        <div className="error">{this.state.formErrors['email']}</div>
                                    )}
                                </div>
                            </div>
                            <div className="container">
                                <div className="input-container">
                                    <label htmlFor="emailConfirm">Bitte bestätigen Sie Ihre E-Mail Adresse</label>
                                    <input
                                        type="email"
                                        className={
                                            this.state.formErrors['emailConfirm'] &&
                                            this.state.formErrors['emailConfirm'].length > 0
                                                ? 'error'
                                                : ''
                                        }
                                        name="emailConfirm"
                                        autoComplete="email"
                                        onBlur={(event) => {
                                            this.handleChange(event);
                                        }}
                                        onChange={(event) => {
                                            this.setState({
                                                emailConfirm: sanitizeInput(event.target.value),
                                            });
                                        }}
                                        value={this.state.emailConfirm || ''}
                                    />
                                    {this.state.formErrors['emailConfirm'] &&
                                        this.state.formErrors['emailConfirm'].length > 0 && (
                                            <div className="error">{this.state.formErrors['emailConfirm']}</div>
                                        )}
                                </div>
                            </div>
                        </article>
                    </section>
                    <section className="section-submit">
                        <div className="container">
                            <div className="row button-container">
                                <button
                                    className="button-back"
                                    onClick={(event) => {
                                        this.handleBack(event);
                                    }}>
                                    <Icon name="keyboardArrowLeft" ariaHidden />
                                    Zurück zu den Nachweisen
                                </button>
                                <this.Submit key="submit" />
                            </div>
                        </div>
                    </section>
                </form>
            </>
        );
    }

    // Components

    Submit() {
        return <Button type="submit" label="Weiter zur Zusammenfassung" />;
    }
}

export default ClaimContactForm;
